var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 479,
    height: 227,
    viewBox: "0 0 479 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2336_209153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.648 132.84V159.09H12.0938L11 139.266L96.8594 4.73438H123.246L94.6719 53.6797L45.3164 132.84H155.648ZM130.766 4.73438V203.797H97.8164V4.73438H130.766Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.406 87.5859V120.125C307.406 135.711 305.857 149.018 302.758 160.047C299.75 170.984 295.375 179.871 289.633 186.707C283.891 193.543 277.009 198.556 268.988 201.746C261.059 204.936 252.172 206.531 242.328 206.531C234.49 206.531 227.198 205.529 220.453 203.523C213.799 201.518 207.784 198.374 202.406 194.09C197.029 189.806 192.426 184.292 188.598 177.547C184.861 170.711 181.944 162.553 179.848 153.074C177.842 143.595 176.84 132.612 176.84 120.125V87.5859C176.84 71.9089 178.389 58.6927 181.488 47.9375C184.587 37.0911 189.008 28.2956 194.75 21.5508C200.492 14.7148 207.328 9.7474 215.258 6.64844C223.279 3.54948 232.211 2 242.055 2C249.984 2 257.276 3.0026 263.93 5.00781C270.674 6.92188 276.69 9.97526 281.977 14.168C287.354 18.3607 291.911 23.8294 295.648 30.5742C299.477 37.2279 302.393 45.2943 304.398 54.7734C306.404 64.1615 307.406 75.099 307.406 87.5859ZM274.457 124.773V82.6641C274.457 74.7344 274.001 67.7617 273.09 61.7461C272.178 55.6393 270.811 50.4896 268.988 46.2969C267.257 42.013 265.069 38.5495 262.426 35.9062C259.783 33.1719 256.775 31.2122 253.402 30.0273C250.03 28.7513 246.247 28.1133 242.055 28.1133C236.951 28.1133 232.393 29.1159 228.383 31.1211C224.372 33.0352 221 36.1341 218.266 40.418C215.531 44.7018 213.435 50.3529 211.977 57.3711C210.609 64.2982 209.926 72.7292 209.926 82.6641V124.773C209.926 132.794 210.382 139.858 211.293 145.965C212.204 152.072 213.572 157.312 215.395 161.688C217.217 165.971 219.405 169.526 221.957 172.352C224.6 175.086 227.608 177.091 230.98 178.367C234.444 179.643 238.227 180.281 242.328 180.281C247.523 180.281 252.126 179.279 256.137 177.273C260.147 175.268 263.52 172.078 266.254 167.703C268.988 163.237 271.039 157.449 272.406 150.34C273.773 143.23 274.457 134.708 274.457 124.773Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.44 37.8807L220.453 25.2969L294.159 171.801L269.146 184.385L195.44 37.8807Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.629 132.84V159.09H324.074L322.98 139.266L408.84 4.73438H435.227L406.652 53.6797L357.297 132.84H467.629ZM442.746 4.73438V203.797H409.797V4.73438H442.746Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2336_209153",
    x: 0,
    y: 0,
    width: 478.629,
    height: 226.531,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2336_209153"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2336_209153",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.7835bb29d4b82ab6cd14fa8763cf742a.svg";
export { ForwardRef as ReactComponent };